
import React, { useRef, useState } from "react";
import { FoundationsButton } from "../../GenericComponents/button";
import { PSFS_StatPortalProps } from "./Psfs_Slice";
declare let window: any
const UnicornApp = window.unicornInstance as any

const OneTwoDayReminderCall: React.FC<PSFS_StatPortalProps> = ({ form, setForm, handleStepStatusAndSave, PSFSElements, stepManuallyChanged, handleStatusResetAndClose, handleSave }) => {
    const formRef = useRef(null as any);
    const [isCustomerSite] = useState<boolean>(UnicornApp.checkUserPrivileges("NTSPAdmin"))

    // Check if this step is already completed (form has moved past this step)
    const currentStepNo = PSFSElements?.PSFSStep?.find(step => step.ETLMatchValue === "1-2DayReminderCall")?.StepNo ?? 1;
    const isStepCompleted = !stepManuallyChanged && form.fk_Step !== undefined && form.fk_Step !== -1 && form.fk_Step > currentStepNo;


    return (
        <>
            <form
                className="psfs-form-container"
                ref={formRef}
            >
                <div className="psfs-container mb-1">
                    <div className="first-child mb-4">
                        <div className="form-group mt-2">
                            <p style={{ lineHeight: "2.2" }}>
                                <label className="mb-3">Call veteran 1-2 days prior to appointment</label><br />
                                1. Reminding veteran of their appointment the next day and how to connect via link VVC App.<br />
                                2. Ask veteran to start connecting 15 minutes prior. Someone will call tomorrow to help get connected if needed<br />
                                3. Remind veteran to have pill bottles for active meds available, as well as blood pressure machine and pulse ox.<br />
                                4. Offer to do a Test Call w/peripherals<br />
                                5. Offer help installing Stroke Recovery app if not done during 1 week call.
                            </p>
                        </div>
                        <div className="form-group psfs-buttons mt-10">
                            {!isStepCompleted && (

                                <span>
                                    {PSFSElements?.PSFSStatus
                                        .filter((status: any) => status.FriendlyName === "Reminder Call Complete")
                                        .map((status: any) => (
                                            <span key={status._key}>
                                                <FoundationsButton
                                                    id={status._key}
                                                    tabIndex={1}
                                                    disabled={!isCustomerSite}
                                                    buttonClasses="psfs-green-button"
                                                    onClick={() => handleStepStatusAndSave("1-2DayReminderCall", status._key, "QualityCheck")}
                                                >
                                                    {status.FriendlyName}
                                                </FoundationsButton>
                                            </span>
                                        ))}
                                </span>
                            )}
                            <span>
                                <FoundationsButton
                                    id="-1"
                                    tabIndex={2}
                                    buttonClasses="app-button"
                                    onClick={() => handleSave(false)}
                                >
                                    Save
                                </FoundationsButton>
                            </span>
                            {!isStepCompleted && (
                                <>
                                    <span>
                                        {PSFSElements?.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "Veteran Declined Appt.")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={3}
                                                        disabled={!isCustomerSite}
                                                        buttonClasses="psfs-red-button"
                                                        onClick={() => handleStatusResetAndClose("1-2DayReminderCall", status._key, "QualityCheck")}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}
                                    </span>

                                    <span>
                                        {PSFSElements?.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "Clinically Canceled")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={4}
                                                        disabled={!isCustomerSite}
                                                        buttonClasses="psfs-red-button"
                                                        onClick={() => handleStatusResetAndClose("1-2DayReminderCall", status._key, "QualityCheck")}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </>

    )

}

export default OneTwoDayReminderCall;